import { useState } from 'react';

// User picker for assigning / reassigning a quote for second review
// (spec docs/archive/202609/specs_20260916_quote_review.md). Presentational: the parent owns
// the api.post and passes the eligible `assignees` ({user_id, name}).
export default function AssignReviewDialog({ title = 'Assign for review', assignees = [], busy, onCancel, onConfirm }) {
    const [selected, setSelected] = useState('');
    const chosen = assignees.find(a => String(a.user_id) === selected);

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <button className="modal-close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <label className="qa-consign-share">
                        <span>Assign to</span>
                        <select className="form-input" value={selected} onChange={e => setSelected(e.target.value)}>
                            <option value="">Select a person…</option>
                            {assignees.map(a => <option key={a.user_id} value={a.user_id}>{a.name}</option>)}
                        </select>
                    </label>
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-accent" disabled={busy || !chosen}
                        onClick={() => onConfirm({ assignee_user_id: chosen.user_id, assignee_name: chosen.name })}>
                        {busy ? '…' : 'Assign'}
                    </button>
                </div>
            </div>
        </div>
    );
}
